import React from 'react';

var TopbarContext = /*#__PURE__*/React.createContext({
  width: undefined
});

export { TopbarContext };
